import React, { useState } from "react";
import "./lawyerSignup.css";
import NarrowInputField from "../../components/input/new/narrowInputField";
import NarrowDropdown2 from "../../components/input/new/narrowDropdown2";
import SignupImg from "./assets/signupImg.png";
import Footer from "../../components/footer";
import SignupToolbar from "../../components/lawyerToolbar/signupToolbar";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook
import { updateLegalInfo } from "../../redux/attorneySlice";
import { useDispatch } from "react-redux";
import IconCheckbox from "../../components/input/new/iconCheckbox";

const practiceAreas = [
  { label: "Criminal Law", value: "criminal_law" },
  { label: "Corporate Law", value: "corporate_law" },
  { label: "Family Law", value: "family_law" },
  { label: "Intellectual Property Law", value: "intellectual_property_law" },
  { label: "Tax Law", value: "tax_law" },
  { label: "Environmental Law", value: "environmental_law" },
  { label: "Labor Law", value: "labor_law" },
  { label: "Real Estate Law", value: "real_estate_law" },
  { label: "Immigration Law", value: "immigration_law" },
  { label: "Bankruptcy Law", value: "bankruptcy_law" },
  { label: "Entertainment Law", value: "entertainment_law" },
  { label: "Personal Injury Law", value: "personal_injury_law" },
  { label: "Medical Malpractice Law", value: "medical_malpractice_law" },
  { label: "Constitutional Law", value: "constitutional_law" },
  { label: "Human Rights Law", value: "human_rights_law" },
  { label: "Trust and Estate Law", value: "trust_and_estate_law" },
  { label: "International Law", value: "international_law" },
  { label: "Antitrust Law", value: "antitrust_law" },
  { label: "Admiralty Law", value: "admiralty_law" },
  { label: "Health Law", value: "health_law" },
];

const firmSizes = [
  { label: "Solo Practitioner", value: "solo" },
  { label: "2-10 Attorneys", value: "2-10" },
  { label: "11-50 Attorneys", value: "11-50" },
  { label: "51-200 Attorneys", value: "51-200" },
  { label: "200+ Attorneys", value: "200+" },
];

const hearAboutUsOptions = [
  { label: "Google or other search engine", value: "search_engine" },
  {
    label: "Social media (e.g. Facebook, Instagram, Twitter)",
    value: "social_media",
  },
  { label: "Referral from a friend or colleague", value: "referral" },
  { label: "Online advertisement", value: "online_ad" },
  { label: "Industry event or conference", value: "event" },
  { label: "Email newsletter or campaign", value: "email_newsletter" },
  { label: "Blog or online article", value: "blog" },
  { label: "Other", value: "other" },
];

export default function LawyerSignup() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    firmName: "",
    practiceAreas: [],
    firmSize: "",
    emailAddress: "",
    phoneNumber: "",
    zipCode: "",
    referral: "",
  });

  const isFormValid =
    formData.firstName.trim() !== "" &&
    formData.lastName.trim() !== "" &&
    formData.firmName.trim() !== "" &&
    formData.practiceAreas.length > 0 &&
    formData.firmSize.trim() !== "" &&
    formData.emailAddress.trim() !== "" &&
    formData.phoneNumber.trim() !== "" &&
    formData.zipCode.trim() !== "" &&
    formData.referral.trim() !== "";

  const [communication, setCommunication] = useState(true);
  const navigate = useNavigate(); // Initialize the navigate function

  const dispatch = useDispatch();

  // Generic change handler for form inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePracticeAreasChange = (selectedValue) => {
    if (selectedValue.length <= 3) {
      setFormData((prev) => ({ ...prev, practiceAreas: selectedValue }));
    } else {
      // Optionally, show a message to the user or remove the extra selection
      console.log("You can select up to 3 practice areas.");
    }
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      updateLegalInfo({
        firstName: formData.firstName,
        lastName: formData.lastName,
        firmName: formData.firmName,
        practiceAreas: formData.practiceAreas,
        firmSize: formData.firmSize,
        email: formData.emailAddress,
        phone_number: formData.phoneNumber,
        zipCode: formData.zipCode,
        referral: formData.referral,
        communicationPreference: communication,
      })
    );
    navigate("/grow/set-password");

    // Process form data here
    console.log("Submitted form data:", formData);
  };

  const handleFirmSizeChange = (selectedValue) => {
    setFormData((prev) => ({ ...prev, firmSize: selectedValue }));
  };

  const handleReferralChange = (selectedValue) => {
    setFormData((prev) => ({ ...prev, referral: selectedValue }));
  };

  return (
    <div className="lawyer-signup-container">
      <SignupToolbar />

      {/* Main wrapper */}
      <div className="signup-wrapper">
        {/* Left Side: Intro / Illustration */}
        <div className="left-section">
          <img src={SignupImg} alt="Globe" className="globe-img" />
          <h2 className="left-section-title">Let’s get started</h2>
          <p className="left-section-text">
            Join quidpro and experience efficient client engagement—only pay
            when a connection is made. Watch your focus shift to what truly
            matters at your firm while you pave the way to success.
          </p>
        </div>

        {/* Right Side: Sign Up Form */}
        <div className="right-section">
          <form className="signup-form" noValidate>
            {/* User name */}
            <div style={{ display: "flex", gap: "16px", width: "425px" }}>
              <NarrowInputField
                name="firstName"
                title="First Name"
                placeholder="Enter first name"
                isRequired={true}
                value={formData.firstName}
                onChange={handleChange}
                halfWidth={true}
              />
              <NarrowInputField
                name="lastName"
                title="Last Name"
                placeholder="Enter last name"
                isRequired={true}
                value={formData.lastName}
                onChange={handleChange}
                halfWidth={true}
              />
            </div>

            <NarrowInputField
              name="firmName"
              title="Firm Name"
              placeholder="Enter Firm Name"
              isRequired={true}
              value={formData.firmName}
              onChange={handleChange}
            />

            <NarrowDropdown2
              title="Practice Areas"
              subLabel="Select up to 3"
              placeholder="Select"
              items={practiceAreas}
              isRequired={true}
              value={formData.practiceAreas}
              onChange={handlePracticeAreasChange}
              multiple={true}
            />

            <NarrowDropdown2
              title="Select Firm Size"
              placeholder="Select"
              subLabel="Include all attorneys at your firm"
              items={firmSizes}
              isRequired={true}
              value={formData.firmSize}
              onChange={handleFirmSizeChange}
              multiple={false}
            />

            <NarrowInputField
              name="emailAddress"
              title="Email Address"
              placeholder="Enter Email Address"
              isRequired={true}
              value={formData.emailAddress}
              subLabel="This email will be used to log in"
              onChange={handleChange}
            />

            <NarrowInputField
              name="phoneNumber"
              title="Phone Number"
              placeholder="Enter Phone Number"
              isRequired={true}
              value={formData.phoneNumber}
              onChange={handleChange}
            />

            <NarrowInputField
              name="zipCode"
              title="Zipcode"
              placeholder="Enter Zipcode"
              isRequired={true}
              value={formData.zipCode}
              onChange={handleChange}
            />

            <NarrowDropdown2
              title="How did you hear about us?"
              placeholder="Select"
              items={hearAboutUsOptions}
              isRequired={true}
              value={formData.referral}
              onChange={handleReferralChange}
              multiple={false}
            />

            {/* Sign up button */}
            <button
              type="submit"
              onClick={handleSubmit}
              className="signup-button"
              disabled={!isFormValid} // Button is disabled when the form is not valid
            >
              Sign up
            </button>

            <button type="submit" className="demo-button">
              Request a demo
            </button>

            {/* Already have an account? */}
            <div className="login-redirect">
              Already have an account? <a href="/grow/email">Log in</a>
            </div>

            <div className="contact-checkbox">
              <IconCheckbox
                checked={communication}
                onChange={setCommunication}
                // onClick={(e) => setCommunication(e.target.checked)}
              />
              <p className="contact-text">
                By checking this box, I consent to receive text messages and
                emails from Quidpro with exclusive offers and updates about the
                platform.
              </p>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}
